import { useState } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { OnSelectChange } from '@ui/src';
import { CorporateFormValues } from '../../../../hoc/new-application/types';

const useRequiredCurrencies = ({
  values,
  index,
  setValue,
  setValuesList,
}: {
  values: {
    id: string;
    name: string;
  }[];
  index: number;
  setValue: UseFormSetValue<CorporateFormValues>;
  setValuesList: (
    data: {
      id: string;
      name: string;
    }[],
  ) => void;
}) => {
  const [errorVisible, setErrorVisible] = useState(false);

  const onChange = (e: OnSelectChange) => {
    if (!values.find((item) => item.id === e.target.value)) {
      const nextValues = values.map((item, valueIndex) => {
        const result = { ...item };

        if (index === valueIndex) {
          result.name = e.target.name;
          result.id = e.target.value as string;
        }

        return result;
      });

      setValue(
        'requiredCurrenciesCryptoId',
        nextValues.map((item) => item.id),
      );

      setValuesList(nextValues);
      setErrorVisible(false);
    } else {
      setErrorVisible(true);
    }
  };

  const deleteCurrency = (id: string) => {
    let nextValues;

    if (id) {
      nextValues = values.filter((item) => item.id !== id);
    } else {
      nextValues = values.filter((item, itemIndex) => index !== itemIndex);
    }

    setValue(
      'requiredCurrenciesCryptoId',
      nextValues.map((item) => item.id),
    );

    setValuesList(nextValues);
  };

  return {
    onChange,
    deleteCurrency,
    errorVisible,
  };
};

export default useRequiredCurrencies;
